import '../css/marketing.css';

import { createBrowserInertiaApp } from './lib/create-browser-inertia-app';

createBrowserInertiaApp({
    entry: 'marketing',
    pages: import.meta.glob([
        './pages/welcome.tsx',
        './pages/presse.tsx',
        './pages/impressum.tsx',
        './pages/datenschutz.tsx',
        './pages/agb.tsx',
        './pages/help.tsx',
        './pages/verbaende.tsx',
        './pages/partner-kit.tsx',
        './pages/haus-und-grund.tsx',
        './pages/haus-und-grund-duesseldorf.tsx',
        './pages/immoscout24.tsx',
        './pages/partner-landing.tsx',
        './pages/autor/**/*.tsx',
        './pages/marketing-pages/**/*.tsx',
        // Guest auth stays in this entry so home ↔ login is an Inertia visit.
        // Successful auth must not resolve app-only pages here: those
        // controllers return Inertia::location() (full document navigation).
        './pages/auth/**/*.tsx',
        './pages/error/**/*.tsx',
        './pages/error-fallback.tsx',
    ]),
});
